export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/PartyShop_Mobile-8668755dbcd4650eb4850f9e68519d30.jpg";